module.exports = __webpack_public_path__ + "img/axians.14029b6f.svg";